
import React from "react"

import siteMetadata from "./site"

import LinkedInLogo from "./icons/in-logo.svg"
import ColoredLinkedInLogo from "./icons/in-logo-hover.svg"

import TwitterLogo from "./icons/tw-logo.svg"
import ColoredTwitterLogo from "./icons/tw-logo-hover.svg"

import StackOverflowLogo from "./icons/so-logo.svg"
import ColoredStackOverflowLogo from "./icons/so-logo-hover.svg"

import GitHubLogo from "./icons/gh-logo.svg"
import ColoredGitHubLogo from "./icons/gh-logo-hover.svg"

import XingLogo from "./icons/xing-logo.svg"
import ColoredXingLogo from "./icons/xing-logo-hover.svg"


function SocialIcons() {
  const { site } = siteMetadata()
  // TODO: add substack
  return (
    <>
      <a href={site.siteMetadata?.socials?.linkedin} className="grid -mt-1" title="LinkedIn">
        <img className="z-10 duration-200 opacity-0 grid-area-full hover:opacity-100" src={ColoredLinkedInLogo} alt="LI" width="29" height="30" />
        <img className="opacity-100 grid-area-full hover:opacity-0" src={LinkedInLogo} alt="li" width="29" height="30" />
      </a>
      <a href={site.siteMetadata?.socials?.twitter} className="grid" title="Twitter">
        <img className="z-10 duration-200 opacity-0 grid-area-full hover:opacity-100" src={ColoredTwitterLogo} alt="TW" width="30" height="22" />
        <img className="opacity-100 grid-area-full hover:opacity-0" src={TwitterLogo} alt="tw" width="30" height="22" />
      </a>
      <a href={site.siteMetadata?.socials?.stackoverflow} className="grid" title="Stack Overflow">
        <img className="z-10 duration-200 opacity-0 grid-area-full hover:opacity-100" src={ColoredStackOverflowLogo} alt="SO" width="22" height="27" />
        <img className="opacity-100 grid-area-full hover:opacity-0" src={StackOverflowLogo} alt="so" width="22" height="27" />
      </a>
      <a href={site.siteMetadata?.socials?.github} className="grid" title="GitHub">
        <img className="z-10 duration-200 opacity-0 grid-area-full hover:opacity-100" src={ColoredGitHubLogo} alt="GH" width="23" height="29" />
        <img className="opacity-100 grid-area-full hover:opacity-0" src={GitHubLogo} alt="gh" width="23" height="29" />
      </a>
    </>
  );
}

export default SocialIcons
